import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {catchError, map, scan, shareReplay, tap} from 'rxjs/operators';
import {EMPTY, merge, Subject, throwError} from 'rxjs';

const API_URL = environment.apiUrl;


@Injectable({providedIn: 'root'})
export class PersonaService {

  colaboradores$ = this.http.get<any[]>(`${API_URL}/api/Personas/colaboradores`)
    .pipe(
      catchError(this.handleError)
    );

  private teacherInsertedSubject = new Subject<any>();
  teacherInsertedAction$ = this.teacherInsertedSubject.asObservable();
  colaboradoresOp$ = merge(
    this.colaboradores$,
    this.teacherInsertedAction$
  ).pipe(
    scan((acc, value) => {
      if (value.op === 'remove') {
        return acc.filter(teacherI => teacherI.id !== value.teacher.id);
      }
      if (value.op === 'add') {
        return [...acc, value.teacher];
      }
    }),
    map(data => data.sort((a, b) => this.sortAlphabetically(a, b))
    )
  );

  constructor(private http: HttpClient) {
  }

  addTeacher(teacher) {
    this.teacherInsertedSubject.next({op: 'add', teacher});
  }

  removeTeacher(teacher) {
    this.teacherInsertedSubject.next({op: 'remove', teacher});
  }

  private sortAlphabetically(a, b) {
    const textA = a.apellidosNombres.toUpperCase(),
      textB = b.apellidosNombres.toUpperCase();
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
  }

  private handleError(err: any) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage: string;
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.statusText}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `Backend returned code ${err.status}: ${err.body.error}`;
    }
    console.error(err);
    return throwError(errorMessage);
  }
}
